/*
  ST 2026-10-25 (Wrike 4591274531, Ali 25.10.): Halloween campaign, loaded by snippets/st-hw-head.liquid.
  1. [data-st-hw-copy]: copies the code (theme setting st_campaign_code), shows a check for 2 s, announces it for screen
     readers and pushes dataLayer event "st_hw_code_copy".
     The Halloween pop-up was removed in round 7 (Ali 25.10.); the Klaviyo pop-up behaves as on live again.
  2. Hero video (snippets/st-hw-hero.liquid, Ali 25.10. R3): loads the 16:9 or 9:16 file for the viewport only while
     html.st-hw is set; no load with reduced motion or data saver (the key visual stays the poster).
     Round 2 (Wrike 4591972060): only the DE/AT/CH files carry data-endcard. From that second until the loop restarts,
     the HTML overlay fades out (inert) and the full-hero link [data-st-hw-endlink] is shown instead.
  3. Top-Deal sticky chip ([data-st-hw-fit], sections/main-product.liquid, round 10): the label is never cut. Full label
     if it fits, else the short one ("Top"), else no chip (the strip above already says "Halloween Top-Deal"). Measured
     in the browser, so it holds for every font, language and saving amount; re-checked on resize, variant change and
     at the campaign switch.
*/
(function () {
  if (window.__stHalloween) return;
  window.__stHalloween = true;

  var status = document.createElement("span");
  status.className = "sr-only";
  status.setAttribute("role", "status");
  var mountStatus = function () {
    if (!status.isConnected && document.body) document.body.appendChild(status);
  };

  var writeText = function (text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacyCopy(text);
      });
    }
    return Promise.resolve(legacyCopy(text));
  };
  var legacyCopy = function (text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {}
    ta.remove();
  };

  document.addEventListener("click", function (event) {
    var el = event.target.closest("[data-st-hw-copy]");
    if (!el) return;
    var code = el.getAttribute("data-st-hw-copy");
    if (!code) return;
    event.preventDefault();
    event.stopPropagation();
    writeText(code).then(function () {
      el.classList.add("is-copied");
      setTimeout(function () {
        el.classList.remove("is-copied");
      }, 2000);
      mountStatus();
      status.textContent = el.getAttribute("data-copied") || code;
      window.dataLayer = window.dataLayer || [];
      // Wrike 4595286836: own event in the Early Black Week phase (html.st-ebw, snippets/st-hw-head.liquid)
      var copyEvent = document.documentElement.classList.contains("st-ebw") ? "st_ebw_code_copy" : "st_hw_code_copy";
      window.dataLayer.push({ event: copyEvent, st_placement: el.getAttribute("data-st-hw-placement") || "" });
    });
  });
})();

(function () {
  var video = document.querySelector("[data-st-hw-video]");
  if (!video) return;
  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  var phone = window.matchMedia("(max-width: 767px)");
  var saveData = navigator.connection && navigator.connection.saveData;

  var hero = video.closest(".st-hw-hero");
  var inner = hero && hero.querySelector(".st-hw-hero__inner");
  var endLink = hero && hero.querySelector("[data-st-hw-endlink]");
  var endAt = parseFloat(video.dataset.endcard);
  var setEnd = function (on) {
    if (!inner || !endLink || hero.classList.contains("is-st-hw-end") === on) return;
    var hadFocus = document.activeElement === endLink;
    hero.classList.toggle("is-st-hw-end", on);
    if (on) inner.setAttribute("inert", "");
    else inner.removeAttribute("inert");
    endLink.hidden = !on;
    var btn = inner.querySelector(".st-hw-btn");
    if (hadFocus && btn) btn.focus();
  };
  if (endAt > 0) {
    video.addEventListener("timeupdate", function () {
      setEnd(video.currentTime >= endAt);
    });
    video.addEventListener("emptied", function () {
      setEnd(false);
    });
  }

  video.muted = true;
  video.addEventListener("playing", function () {
    video.classList.add("is-playing");
  });
  var load = function () {
    if (reduce.matches || saveData || !root.classList.contains("st-hw")) {
      video.pause();
      video.classList.remove("is-playing");
      setEnd(false);
      return;
    }
    var src = phone.matches ? video.dataset.srcMobile : video.dataset.srcDesktop;
    if (video.getAttribute("src") !== src) {
      video.classList.remove("is-playing");
      video.src = src;
    }
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  };
  load();
  [phone, reduce].forEach(function (mq) {
    if (mq.addEventListener) mq.addEventListener("change", load);
  });
})();

(function () {
  var forms = document.querySelectorAll("product-sticky-form.st-hw-td");
  if (!forms.length) return;
  var root = document.documentElement;

  var fit = function () {
    var chips = document.querySelectorAll("[data-st-hw-fit]");
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var full = chip.querySelector("[data-st-hw-chip-full]");
      var short = chip.querySelector("[data-st-hw-chip-short]");
      if (!full || !short) continue;
      chip.classList.remove("is-st-hw-nofit");
      full.hidden = false;
      short.hidden = true;
      if (chip.hidden || !root.classList.contains("st-hw") || !chip.clientWidth) continue;
      if (chip.scrollWidth <= chip.clientWidth) continue;
      full.hidden = true;
      short.hidden = false;
      if (chip.scrollWidth > chip.clientWidth) chip.classList.add("is-st-hw-nofit");
    }
  };

  // Only text/child changes re-run it (theme.js swaps #StickyPrice on variant change, the saving text is rewritten);
  // fit() itself changes attributes only, so it does not trigger itself.
  var mo = new MutationObserver(fit);
  var ro = window.ResizeObserver ? new ResizeObserver(fit) : null;
  for (var i = 0; i < forms.length; i++) {
    mo.observe(forms[i], { childList: true, subtree: true, characterData: true });
    if (ro) ro.observe(forms[i]);
  }
  new MutationObserver(fit).observe(root, { attributes: true, attributeFilter: ["class"] });
  if (!ro) window.addEventListener("resize", fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  fit();
})();
